export enum PersistentCookiesKeys {
  CognitoSession = 'LB_cognito_session', // store cognito jwt and deviceKey to authenticate api requests
  EvoToken = 'evoToken', // allows communication of auth session between v1 and v2
  LbImp = 'LB_imp',
}
